// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes akmSlideIn {
  from { transform: translateX(100%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

/* ── Header ─────────────────────────────────────────────── */
.akm-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #f0f2f5;
  flex-shrink: 0;
}

.akm-header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.akm-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #111827;
}

.akm-list-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.akm-toggle-label {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
}

.akm-toggle-switch {
  width: 36px;
  height: 20px;
  border-radius: 999px;
  background: #d1d5db;
  position: relative;
  transition: background 0.2s;
}

.akm-toggle-switch.on {
  background: #2563eb;
}

.akm-toggle-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: left 0.2s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.akm-toggle-switch.on .akm-toggle-knob {
  left: 18px;
}

.akm-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  color: #6b7280;
  transition: background 0.15s;
}

.akm-close-btn:hover { background: #f3f4f6; }

/* ── Subtitle ───────────────────────────────────────────── */
.akm-subtitle {
  font-size: 12px;
  color: #6b7280;
  padding: 8px 20px 12px;
  border-bottom: 1px solid #f0f2f5;
  margin: 0;
  flex-shrink: 0;
  line-height: 1.5;
}

/* ── Scrollable body ────────────────────────────────────── */
.akm-body {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px 16px;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.akm-body::-webkit-scrollbar { width: 4px; }
.akm-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }

.akm-empty {
  text-align: center;
  color: #9ca3af;
  font-size: 13px;
  padding: 48px 0;
}

/* ── KOT Group ──────────────────────────────────────────── */
.akm-group {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  margin-bottom: 12px;
}

.akm-group-header {
  padding: 12px 16px;
  background: #fff;
  cursor: pointer;
  user-select: none;
  border-bottom: 1px solid #f0f2f5;
  transition: background 0.12s;
}

.akm-group-header:hover { background: #f9fafb; }

.akm-group-header-content { display: flex; flex-direction: column; gap: 4px; }

.akm-group-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.akm-group-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.akm-group-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.akm-group-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.akm-group-meta {
  font-size: 12px;
  color: #6b7280;
}

/* ── Item card ──────────────────────────────────────────── */
.akm-group-body { padding: 10px 12px; display: flex; flex-direction: column; gap: 10px; }

.akm-item-card {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 12px 14px;
  background: #fff;
}

.akm-item-card.recalled { background: #fff5f5; border-color: #fecaca; }
.akm-item-card.complimentary { background: #f0fdf4; border-color: #bbf7d0; }

.akm-item-card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 6px;
}

.akm-item-card-name-row {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex: 1;
  flex-wrap: nowrap;
}

.akm-food-dot { width: 16px; height: 16px; flex-shrink: 0; }

.akm-item-card-name-col {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.akm-item-card-name {
  font-size: 14px;
  font-weight: 700;
  color: #111827;
}

.akm-item-card-variant {
  font-size: 12px;
  font-weight: 500;
  color: #6b7280;
  line-height: 1.3;
}

/* ── Badges ─────────────────────────────────────────────── */
.akm-badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 999px;
  flex-shrink: 0;
}

.akm-badge.recalled  { color: #dc2626; background: #fee2e2; border: 1px solid #fca5a5; }
.akm-badge.complimentary { color: #059669; background: #d1fae5; border: 1px solid #6ee7b7; }

/* ── Price box ──────────────────────────────────────────── */
.akm-item-price-box {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  min-width: 64px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.akm-item-price-box.comp-price {
  background: #f0fdf4;
  border-color: #86efac;
}

.akm-price-main { font-size: 16px; font-weight: 700; color: #111827; }
.akm-price-zero { font-size: 16px; font-weight: 700; color: #111827; }
.akm-price-strike { font-size: 11px; color: #9ca3af; text-decoration: line-through; font-weight: 500; }

/* ── Addons / Note ──────────────────────────────────────── */
.akm-item-card-addons {
  font-size: 12px;
  color: #6b7280;
  margin: 0 0 4px;
  line-height: 1.5;
}

.akm-item-card-note {
  font-size: 12px;
  color: #d97706;
  font-weight: 500;
  margin: 0 0 6px;
}

/* ── KOT source label (list view) ───────────────────────── */
.akm-item-card-kot-label {
  font-size: 11px;
  color: #9ca3af;
  margin: 4px 0 0;
  line-height: 1.4;
}

/* ── Action buttons ─────────────────────────────────────── */
.akm-item-card-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.akm-action-btn {
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 30px;
  cursor: pointer;
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  font-family: inherit;
  white-space: nowrap;
  transition: all 0.12s;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 30px;
}

.akm-action-btn.comp {
  border-color: #e5e7eb;
  color: #374151;
}
.akm-action-btn.comp:hover:not(:disabled) { background: #f9fafb; }

.akm-action-btn.remove-comp {
  background: #f0fdf4;
  border-color: #86efac;
  color: #16a34a;
  font-weight: 700;
}
.akm-action-btn.remove-comp:hover:not(:disabled) { background: #dcfce7; }

.akm-action-btn.discount {
  border-color: #e5e7eb;
  color: #374151;
}
.akm-action-btn.discount:hover { background: #f9fafb; }

.akm-action-btn.recall {
  border-color: #fca5a5;
  color: #dc2626;
  background: #fff;
}
.akm-action-btn.recall:hover { background: #fee2e2; }

.akm-action-btn.recall-logged {
  background: #f9fafb;
  border-color: #d1d5db;
  color: #9ca3af;
  cursor: default;
}

.akm-action-btn.repeat {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #2563eb;
}
.akm-action-btn.repeat:hover:not(:disabled) { background: #dbeafe; }
.akm-action-btn.repeat:disabled { opacity: 0.6; cursor: not-allowed; }

.akm-action-btn.serve {
  background: #f0fdf4;
  border-color: #bbf7d0;
  color: #15803d;
}
.akm-action-btn.serve:hover:not(:disabled) { background: #dcfce7; }

.akm-action-btn:disabled { opacity: 0.55; cursor: not-allowed; }

/* Complimentary button on recalled items — fully grayed out */
.akm-action-btn.comp:disabled,
.akm-action-btn.remove-comp:disabled {
  background: #f3f4f6;
  border-color: #d1d5db;
  color: #9ca3af;
  opacity: 1;
  cursor: not-allowed;
}

/* ── Group footer ───────────────────────────────────────── */
.akm-group-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f9fafb;
  border-top: 1px solid #f0f2f5;
  border-radius: 0 0 10px 10px;
  margin: 0 -12px -10px;
}

.akm-group-footer-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.akm-group-footer-total {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}

.akm-order-status { display: flex; align-items: center; gap: 6px; }

.akm-status-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
}

.akm-status-text { font-size: 13px; font-weight: 500; color: #374151; }

.akm-reprint-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 30px;
  padding: 5px 12px;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.12s;
  height: 32px;
}

.akm-reprint-btn:hover:not(:disabled) { background: #f3f4f6; border-color: #9ca3af; }
.akm-reprint-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Grand total bar ────────────────────────────────────── */
.akm-grand-total {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-top: 1.5px solid #e5e7eb;
  background: #f9fafb;
}

.akm-grand-total-label {
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.akm-grand-total-amount { font-size: 1.1rem; font-weight: 800; color: #111827; }

/* ── List view ──────────────────────────────────────────── */
.akm-list-view { display: flex; flex-direction: column; gap: 10px; }

.akm-list-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f5;
}

.akm-list-item:last-child { border-bottom: none; }
.akm-list-item.recalled { opacity: 0.65; }
.akm-list-item.complimentary { background: #f0fdf4; border-radius: 6px; padding: 10px 8px; }

.akm-list-item-left { display: flex; align-items: flex-start; gap: 8px; flex: 1; min-width: 0; }

.akm-list-item-name { font-size: 13px; font-weight: 600; color: #111827; }

.akm-list-item-addon {
  font-size: 11px;
  color: #6b7280;
  margin: 3px 0 0;
  padding: 0;
  line-height: 1.4;
}

.akm-list-item-price { font-size: 13px; font-weight: 700; color: #1f2937; white-space: nowrap; flex-shrink: 0; }

/* ═══ DARK THEME — AllKotsModal ═══ */
.dark .akm-title { color: #f1f5f9; }
.dark .akm-toggle-label { color: #cbd5e1; }
.dark .akm-subtitle { color: #94a3b8; border-bottom-color: #334155; }
.dark .akm-close-btn { color: #64748b; }
.dark .akm-close-btn:hover { background: #334155; }

.dark .akm-body { scrollbar-color: #334155 transparent; }
.dark .akm-empty { color: #64748b; }

.dark .akm-group {
  background: #1e293b;
  border-color: #334155;
}
.dark .akm-group-header { background: #1e293b; border-bottom-color: #334155; }
.dark .akm-group-header:hover { background: #243043; }
.dark .akm-group-title { color: #f1f5f9; }
.dark .akm-group-meta  { color: #64748b; }

.dark .akm-item-card {
  background: #0f172a;
  border-color: #334155;
}
.dark .akm-item-card.recalled    { background: #2d0a0a; border-color: #7f1d1d; }
.dark .akm-item-card.complimentary { background: #052e16; border-color: #14532d; }

.dark .akm-item-card-name    { color: #e2e8f0; }
.dark .akm-item-card-variant { color: #94a3b8; }
.dark .akm-item-card-addons  { color: #64748b; }
.dark .akm-item-card-note    { color: #fbbf24; }
.dark .akm-item-card-kot-label { color: #64748b; }

.dark .akm-item-price-box {
  background: #1e293b;
  border-color: #334155;
}
.dark .akm-item-price-box.comp-price { background: #052e16; border-color: #14532d; }
.dark .akm-price-main  { color: #f1f5f9; }
.dark .akm-price-zero  { color: #f1f5f9; }
.dark .akm-price-strike { color: #64748b; }

.dark .akm-action-btn {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
.dark .akm-action-btn.comp:hover:not(:disabled) { background: #334155; }
.dark .akm-action-btn.repeat { background: #1e3a8a; border-color: #1d4ed8; color: #93c5fd; }
.dark .akm-action-btn.repeat:hover:not(:disabled) { background: #1e40af; }
.dark .akm-action-btn.serve { background: #052e16; border-color: #14532d; color: #6ee7b7; }
.dark .akm-action-btn.serve:hover:not(:disabled) { background: #064e3b; }
.dark .akm-action-btn.recall { background: #1e293b; border-color: #991b1b; color: #fca5a5; }
.dark .akm-action-btn.recall:hover { background: #2d0a0a; }
.dark .akm-action-btn.remove-comp { background: #052e16; border-color: #14532d; color: #6ee7b7; }
.dark .akm-action-btn.comp:disabled,
.dark .akm-action-btn.remove-comp:disabled { background: #1e293b; border-color: #334155; color: #475569; }

.dark .akm-group-footer {
  background: #0f172a;
  border-top-color: #334155;
}
.dark .akm-group-footer-total { color: #f1f5f9; }
.dark .akm-status-text { color: #94a3b8; }

.dark .akm-reprint-btn {
  background: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}
.dark .akm-reprint-btn:hover:not(:disabled) { background: #334155; border-color: #475569; }

.dark .akm-grand-total {
  background: #0f172a;
  border-top-color: #334155;
}
.dark .akm-grand-total-label  { color: #64748b; }
.dark .akm-grand-total-amount { color: #f1f5f9; }

.dark .akm-list-item { border-bottom-color: #334155; }
.dark .akm-list-item.complimentary { background: #052e16; }
.dark .akm-list-item-name  { color: #e2e8f0; }
.dark .akm-list-item-addon { color: #64748b; }
.dark .akm-list-item-price { color: #f1f5f9; }

.dark .akm-header { border-bottom-color: #334155; }

/* Per-item kitchen state and elapsed prep window */
.akm-drawer {
  background: #fff;
  color: #111827;
}

.akm-kitchen-notice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 11px 14px;
  margin: 0 0 12px;
  border: 1px solid #e5e7eb;
  border-radius: 9px;
  color: #4b5563;
  background: #f3f4f6;
  font-size: 12px;
}

.akm-kitchen-notice.loading { justify-content: flex-start; }
.akm-kitchen-notice.error { color: #991b1b; background: #fef2f2; border-color: #fecaca; }
.akm-kitchen-notice > div { display: grid; gap: 3px; }
.akm-kitchen-notice strong { font-size: 12px; }
.akm-kitchen-notice span { line-height: 1.4; }
.akm-kitchen-notice-mark {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #64748b;
  animation: akmPulse 1.3s ease-in-out infinite alternate;
}

@keyframes akmPulse { to { opacity: 0.35; } }

.akm-kitchen-retry {
  flex-shrink: 0;
  padding: 6px 11px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: inherit;
  background: transparent;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
}
.akm-kitchen-retry:hover { background: rgba(71, 85, 105, 0.08); }

.akm-kitchen-progress {
  display: grid;
  gap: 6px;
  padding: 9px 10px;
  margin-top: 9px;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #f9fafb;
  color: #4b5563;
  font-size: 11px;
}

.akm-kitchen-progress-top,
.akm-kitchen-state,
.akm-kitchen-progress-bottom {
  display: flex;
  align-items: center;
}
.akm-kitchen-progress-top { justify-content: space-between; gap: 6px 10px; flex-wrap: wrap; }
.akm-kitchen-state { gap: 6px; min-width: 0; }
.akm-kitchen-state-dot { width: 7px; height: 7px; border-radius: 50%; background: #6b7280; flex: 0 0 auto; }
.akm-kitchen-state-label { color: #374151; font-weight: 700; }
.akm-kitchen-time-text { color: #6b7280; font-variant-numeric: tabular-nums; }
.akm-kitchen-time-text strong { font-size: 14px; font-weight: 800; }
.akm-kitchen-progress.tone-green .akm-kitchen-time-text { color: #15803d; }
.akm-kitchen-progress.tone-orange .akm-kitchen-time-text { color: #b45309; }
.akm-kitchen-facts { display: flex; gap: 18px; flex-wrap: wrap; }
.akm-kitchen-facts span { display: flex; align-items: baseline; gap: 5px; }
.akm-kitchen-facts b { color: #6b7280; font-weight: 600; }
.akm-kitchen-prep-fact { flex-wrap: wrap; }
.akm-kitchen-prep-source { color: #6b7280; font-size: 10px; }
.akm-kitchen-progress-bottom { gap: 6px 9px; flex-wrap: wrap; }
.akm-kitchen-meter {
  height: 5px;
  flex: 1;
  min-width: 64px;
  overflow: hidden;
  border-radius: 999px;
  background: #e5e7eb;
}
.akm-kitchen-meter-fill { display: block; height: 100%; border-radius: inherit; background: #15803d; }
.akm-kitchen-progress-label { white-space: nowrap; color: #4b5563; font-variant-numeric: tabular-nums; }
.akm-kitchen-progress.tone-green .akm-kitchen-state-dot,
.akm-kitchen-progress.tone-green .akm-kitchen-meter-fill { background: #15803d; }
.akm-kitchen-progress.tone-orange .akm-kitchen-state-dot,
.akm-kitchen-progress.tone-orange .akm-kitchen-meter-fill { background: #b45309; }
.akm-kitchen-progress.tone-red .akm-kitchen-state-dot,
.akm-kitchen-progress.tone-red .akm-kitchen-meter-fill { background: #b91c1c; }
.akm-kitchen-progress.tone-red .akm-kitchen-time-text,
.akm-kitchen-progress.tone-red .akm-kitchen-progress-label { color: #b91c1c; font-weight: 700; }
.akm-kitchen-progress.tone-neutral .akm-kitchen-state-dot { background: #6b7280; }
.akm-kitchen-state.cancelled .akm-kitchen-state-label { color: #b91c1c; }
.akm-kitchen-progress .akm-kitchen-state.cancelled .akm-kitchen-state-dot { background: #b91c1c; }

.dark .akm-drawer { background: #0f172a; color: #f1f5f9; }
.dark .akm-kitchen-notice { color: #cbd5e1; background: #1e293b; border-color: #334155; }
.dark .akm-kitchen-notice.error { color: #fecaca; background: #3b1717; border-color: #7f1d1d; }
.dark .akm-kitchen-progress { color: #cbd5e1; background: #0f172a; border-color: #334155; }
.dark .akm-kitchen-state-label { color: #e2e8f0; }
.dark .akm-kitchen-state.cancelled .akm-kitchen-state-label { color: #fca5a5; }
.dark .akm-kitchen-progress .akm-kitchen-state.cancelled .akm-kitchen-state-dot { background: #ef4444; }
.dark .akm-kitchen-time-text,
.dark .akm-kitchen-progress-label { color: #cbd5e1; }
.dark .akm-kitchen-facts b,
.dark .akm-kitchen-prep-source { color: #94a3b8; }
.dark .akm-kitchen-meter { background: #334155; }
.dark .akm-kitchen-progress.tone-red .akm-kitchen-time-text,
.dark .akm-kitchen-progress.tone-red .akm-kitchen-progress-label { color: #fca5a5; }
.dark .akm-kitchen-progress.tone-red .akm-kitchen-state-dot,
.dark .akm-kitchen-progress.tone-red .akm-kitchen-meter-fill { background: #ef4444; }
.dark .akm-kitchen-progress.tone-orange .akm-kitchen-state-dot,
.dark .akm-kitchen-progress.tone-orange .akm-kitchen-meter-fill { background: #f59e0b; }
.dark .akm-kitchen-progress.tone-green .akm-kitchen-state-dot,
.dark .akm-kitchen-progress.tone-green .akm-kitchen-meter-fill { background: #22c55e; }

@media (max-width: 767px) {
  .akm-drawer { width: 100vw !important; }
  .akm-header { padding: 15px 14px 12px; }
  .akm-header-left { gap: 10px; }
  .akm-title { font-size: 1.05rem; }
  .akm-subtitle { padding: 8px 14px 11px; }
  .akm-body { padding: 10px 10px 14px; }
  .akm-group-body { padding: 9px; }
  .akm-item-card { padding: 11px; }
  .akm-kitchen-facts { gap: 6px 13px; }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/AllKotsModal/AllKotsModal.css"],"names":[],"mappings":"AAAA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,4BAA4B;AAC9B;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C,8DAA8D;AAC9D;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gCAAgC;EAChC,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,+BAA+B,UAAU,EAAE;AAC3C,qCAAqC,mBAAmB,EAAE,kBAAkB,EAAE;;AAE9E;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C,4BAA4B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8DAA8D;AAC9D,kBAAkB,kBAAkB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAExF;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE,+BAA+B,mBAAmB,EAAE,qBAAqB,EAAE;;AAE3E;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,OAAO;EACP,iBAAiB;AACnB;;AAEA,gBAAgB,WAAW,EAAE,YAAY,EAAE,cAAc,EAAE;;AAE3D;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,uBAAuB,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;AACvF,2BAA2B,cAAc,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AAE3F,8DAA8D;AAC9D;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrE,oBAAoB,eAAe,EAAE,cAAc,EAAE,6BAA6B,EAAE,gBAAgB,EAAE;;AAEtG,8DAA8D;AAC9D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA,4CAA4C,mBAAmB,EAAE;;AAEjE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA,mDAAmD,mBAAmB,EAAE;;AAExE;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA,iCAAiC,mBAAmB,EAAE;;AAEtD;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA,+BAA+B,mBAAmB,EAAE;;AAEpD;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,8CAA8C,mBAAmB,EAAE;AACnE,kCAAkC,YAAY,EAAE,mBAAmB,EAAE;;AAErE;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,6CAA6C,mBAAmB,EAAE;;AAElE,2BAA2B,aAAa,EAAE,mBAAmB,EAAE;;AAE/D,8DAA8D;AAC9D;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,UAAU;EACV,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,oBAAoB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;AAElE;EACE,UAAU,EAAE,WAAW;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEtE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;AACd;;AAEA,wCAAwC,mBAAmB,EAAE,qBAAqB,EAAE;AACpF,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D,8DAA8D;AAC9D;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,0BAA0B,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAE/E,8DAA8D;AAC9D,iBAAiB,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEnE;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gCAAgC;AAClC;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,0BAA0B,aAAa,EAAE;AACzC,+BAA+B,mBAAmB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAE3F,sBAAsB,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,OAAO,EAAE,YAAY,EAAE;;AAE/F,sBAAsB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAEzE;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,gBAAgB;AAClB;;AAEA,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAE/G,sCAAsC;AACtC,mBAAmB,cAAc,EAAE;AACnC,0BAA0B,cAAc,EAAE;AAC1C,sBAAsB,cAAc,EAAE,4BAA4B,EAAE;AACpE,uBAAuB,cAAc,EAAE;AACvC,6BAA6B,mBAAmB,EAAE;;AAElD,kBAAkB,oCAAoC,EAAE;AACxD,mBAAmB,cAAc,EAAE;;AAEnC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,0BAA0B,mBAAmB,EAAE,4BAA4B,EAAE;AAC7E,gCAAgC,mBAAmB,EAAE;AACrD,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,mCAAmC,mBAAmB,EAAE,qBAAqB,EAAE;AAC/E,qCAAqC,mBAAmB,EAAE,qBAAqB,EAAE;;AAEjF,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,+BAA+B,cAAc,EAAE;AAC/C,iCAAiC,cAAc,EAAE;;AAEjD;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA,uCAAuC,mBAAmB,EAAE,qBAAqB,EAAE;AACnF,yBAAyB,cAAc,EAAE;AACzC,yBAAyB,cAAc,EAAE;AACzC,0BAA0B,cAAc,EAAE;;AAE1C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,kDAAkD,mBAAmB,EAAE;AACvE,+BAA+B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC3F,oDAAoD,mBAAmB,EAAE;AACzE,8BAA8B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC1F,mDAAmD,mBAAmB,EAAE;AACxE,+BAA+B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC3F,qCAAqC,mBAAmB,EAAE;AAC1D,oCAAoC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAChG;6CAC6C,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEzG;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,gCAAgC,cAAc,EAAE;AAChD,yBAAyB,cAAc,EAAE;;AAEzC;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA,8CAA8C,mBAAmB,EAAE,qBAAqB,EAAE;;AAE1F;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,gCAAgC,cAAc,EAAE;AAChD,gCAAgC,cAAc,EAAE;;AAEhD,uBAAuB,4BAA4B,EAAE;AACrD,qCAAqC,mBAAmB,EAAE;AAC1D,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;AAC7C,6BAA6B,cAAc,EAAE;;AAE7C,oBAAoB,4BAA4B,EAAE;;AAElD,mDAAmD;AACnD;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA,8BAA8B,2BAA2B,EAAE;AAC3D,4BAA4B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACxF,4BAA4B,aAAa,EAAE,QAAQ,EAAE;AACrD,6BAA6B,eAAe,EAAE;AAC9C,2BAA2B,gBAAgB,EAAE;AAC7C;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA,sBAAsB,KAAK,aAAa,EAAE,EAAE;;AAE5C;EACE,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;AACA,2BAA2B,mCAAmC,EAAE;;AAEhE;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;AACA,4BAA4B,8BAA8B,EAAE,aAAa,EAAE,eAAe,EAAE;AAC5F,qBAAqB,QAAQ,EAAE,YAAY,EAAE;AAC7C,yBAAyB,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC3G,2BAA2B,cAAc,EAAE,gBAAgB,EAAE;AAC7D,yBAAyB,cAAc,EAAE,kCAAkC,EAAE;AAC7E,gCAAgC,eAAe,EAAE,gBAAgB,EAAE;AACnE,0DAA0D,cAAc,EAAE;AAC1E,2DAA2D,cAAc,EAAE;AAC3E,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE;AAChE,0BAA0B,aAAa,EAAE,qBAAqB,EAAE,QAAQ,EAAE;AAC1E,uBAAuB,cAAc,EAAE,gBAAgB,EAAE;AACzD,yBAAyB,eAAe,EAAE;AAC1C,2BAA2B,cAAc,EAAE,eAAe,EAAE;AAC5D,+BAA+B,YAAY,EAAE,eAAe,EAAE;AAC9D;EACE,WAAW;EACX,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;AACA,0BAA0B,cAAc,EAAE,YAAY,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACrG,8BAA8B,mBAAmB,EAAE,cAAc,EAAE,kCAAkC,EAAE;AACvG;2DAC2D,mBAAmB,EAAE;AAChF;4DAC4D,mBAAmB,EAAE;AACjF;yDACyD,mBAAmB,EAAE;AAC9E;6DAC6D,cAAc,EAAE,gBAAgB,EAAE;AAC/F,4DAA4D,mBAAmB,EAAE;AACjF,wDAAwD,cAAc,EAAE;AACxE,4EAA4E,mBAAmB,EAAE;;AAEjG,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,4BAA4B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AACxF,kCAAkC,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC9F,8BAA8B,cAAc,EAAE,mBAAmB,EAAE,qBAAqB,EAAE;AAC1F,iCAAiC,cAAc,EAAE;AACjD,8DAA8D,cAAc,EAAE;AAC9E,kFAAkF,mBAAmB,EAAE;AACvG;oCACoC,cAAc,EAAE;AACpD;iCACiC,cAAc,EAAE;AACjD,2BAA2B,mBAAmB,EAAE;AAChD;mEACmE,cAAc,EAAE;AACnF;+DAC+D,mBAAmB,EAAE;AACpF;kEACkE,mBAAmB,EAAE;AACvF;iEACiE,mBAAmB,EAAE;;AAEtF;EACE,cAAc,uBAAuB,EAAE;EACvC,cAAc,uBAAuB,EAAE;EACvC,mBAAmB,SAAS,EAAE;EAC9B,aAAa,kBAAkB,EAAE;EACjC,gBAAgB,sBAAsB,EAAE;EACxC,YAAY,uBAAuB,EAAE;EACrC,kBAAkB,YAAY,EAAE;EAChC,iBAAiB,aAAa,EAAE;EAChC,qBAAqB,aAAa,EAAE;AACtC","sourcesContent":["@keyframes akmSlideIn {\n  from { transform: translateX(100%); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n/* ── Header ─────────────────────────────────────────────── */\n.akm-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 20px 14px;\n  border-bottom: 1px solid #f0f2f5;\n  flex-shrink: 0;\n}\n\n.akm-header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.akm-title {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #111827;\n}\n\n.akm-list-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  user-select: none;\n}\n\n.akm-toggle-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: #374151;\n}\n\n.akm-toggle-switch {\n  width: 36px;\n  height: 20px;\n  border-radius: 999px;\n  background: #d1d5db;\n  position: relative;\n  transition: background 0.2s;\n}\n\n.akm-toggle-switch.on {\n  background: #2563eb;\n}\n\n.akm-toggle-knob {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #fff;\n  transition: left 0.2s;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.2);\n}\n\n.akm-toggle-switch.on .akm-toggle-knob {\n  left: 18px;\n}\n\n.akm-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border-radius: 6px;\n  color: #6b7280;\n  transition: background 0.15s;\n}\n\n.akm-close-btn:hover { background: #f3f4f6; }\n\n/* ── Subtitle ───────────────────────────────────────────── */\n.akm-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n  padding: 8px 20px 12px;\n  border-bottom: 1px solid #f0f2f5;\n  margin: 0;\n  flex-shrink: 0;\n  line-height: 1.5;\n}\n\n/* ── Scrollable body ────────────────────────────────────── */\n.akm-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 12px 16px 16px;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.akm-body::-webkit-scrollbar { width: 4px; }\n.akm-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }\n\n.akm-empty {\n  text-align: center;\n  color: #9ca3af;\n  font-size: 13px;\n  padding: 48px 0;\n}\n\n/* ── KOT Group ──────────────────────────────────────────── */\n.akm-group {\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.04);\n  margin-bottom: 12px;\n}\n\n.akm-group-header {\n  padding: 12px 16px;\n  background: #fff;\n  cursor: pointer;\n  user-select: none;\n  border-bottom: 1px solid #f0f2f5;\n  transition: background 0.12s;\n}\n\n.akm-group-header:hover { background: #f9fafb; }\n\n.akm-group-header-content { display: flex; flex-direction: column; gap: 4px; }\n\n.akm-group-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.akm-group-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.akm-group-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.akm-group-meta-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.akm-group-meta {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* ── Item card ──────────────────────────────────────────── */\n.akm-group-body { padding: 10px 12px; display: flex; flex-direction: column; gap: 10px; }\n\n.akm-item-card {\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 12px 14px;\n  background: #fff;\n}\n\n.akm-item-card.recalled { background: #fff5f5; border-color: #fecaca; }\n.akm-item-card.complimentary { background: #f0fdf4; border-color: #bbf7d0; }\n\n.akm-item-card-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 6px;\n}\n\n.akm-item-card-name-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  flex: 1;\n  flex-wrap: nowrap;\n}\n\n.akm-food-dot { width: 16px; height: 16px; flex-shrink: 0; }\n\n.akm-item-card-name-col {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.akm-item-card-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.akm-item-card-variant {\n  font-size: 12px;\n  font-weight: 500;\n  color: #6b7280;\n  line-height: 1.3;\n}\n\n/* ── Badges ─────────────────────────────────────────────── */\n.akm-badge {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 2px 8px;\n  border-radius: 999px;\n  flex-shrink: 0;\n}\n\n.akm-badge.recalled  { color: #dc2626; background: #fee2e2; border: 1px solid #fca5a5; }\n.akm-badge.complimentary { color: #059669; background: #d1fae5; border: 1px solid #6ee7b7; }\n\n/* ── Price box ──────────────────────────────────────────── */\n.akm-item-price-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex-shrink: 0;\n  min-width: 64px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n}\n\n.akm-item-price-box.comp-price {\n  background: #f0fdf4;\n  border-color: #86efac;\n}\n\n.akm-price-main { font-size: 16px; font-weight: 700; color: #111827; }\n.akm-price-zero { font-size: 16px; font-weight: 700; color: #111827; }\n.akm-price-strike { font-size: 11px; color: #9ca3af; text-decoration: line-through; font-weight: 500; }\n\n/* ── Addons / Note ──────────────────────────────────────── */\n.akm-item-card-addons {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 0 0 4px;\n  line-height: 1.5;\n}\n\n.akm-item-card-note {\n  font-size: 12px;\n  color: #d97706;\n  font-weight: 500;\n  margin: 0 0 6px;\n}\n\n/* ── KOT source label (list view) ───────────────────────── */\n.akm-item-card-kot-label {\n  font-size: 11px;\n  color: #9ca3af;\n  margin: 4px 0 0;\n  line-height: 1.4;\n}\n\n/* ── Action buttons ─────────────────────────────────────── */\n.akm-item-card-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.akm-action-btn {\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 30px;\n  cursor: pointer;\n  border: 1px solid #e5e7eb;\n  background: #fff;\n  color: #374151;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: all 0.12s;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 30px;\n}\n\n.akm-action-btn.comp {\n  border-color: #e5e7eb;\n  color: #374151;\n}\n.akm-action-btn.comp:hover:not(:disabled) { background: #f9fafb; }\n\n.akm-action-btn.remove-comp {\n  background: #f0fdf4;\n  border-color: #86efac;\n  color: #16a34a;\n  font-weight: 700;\n}\n.akm-action-btn.remove-comp:hover:not(:disabled) { background: #dcfce7; }\n\n.akm-action-btn.discount {\n  border-color: #e5e7eb;\n  color: #374151;\n}\n.akm-action-btn.discount:hover { background: #f9fafb; }\n\n.akm-action-btn.recall {\n  border-color: #fca5a5;\n  color: #dc2626;\n  background: #fff;\n}\n.akm-action-btn.recall:hover { background: #fee2e2; }\n\n.akm-action-btn.recall-logged {\n  background: #f9fafb;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  cursor: default;\n}\n\n.akm-action-btn.repeat {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #2563eb;\n}\n.akm-action-btn.repeat:hover:not(:disabled) { background: #dbeafe; }\n.akm-action-btn.repeat:disabled { opacity: 0.6; cursor: not-allowed; }\n\n.akm-action-btn.serve {\n  background: #f0fdf4;\n  border-color: #bbf7d0;\n  color: #15803d;\n}\n.akm-action-btn.serve:hover:not(:disabled) { background: #dcfce7; }\n\n.akm-action-btn:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* Complimentary button on recalled items — fully grayed out */\n.akm-action-btn.comp:disabled,\n.akm-action-btn.remove-comp:disabled {\n  background: #f3f4f6;\n  border-color: #d1d5db;\n  color: #9ca3af;\n  opacity: 1;\n  cursor: not-allowed;\n}\n\n/* ── Group footer ───────────────────────────────────────── */\n.akm-group-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 14px;\n  background: #f9fafb;\n  border-top: 1px solid #f0f2f5;\n  border-radius: 0 0 10px 10px;\n  margin: 0 -12px -10px;\n}\n\n.akm-group-footer-right {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.akm-group-footer-total {\n  font-size: 15px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.akm-order-status { display: flex; align-items: center; gap: 6px; }\n\n.akm-status-dot {\n  width: 8px; height: 8px;\n  border-radius: 50%;\n  background: #22c55e;\n  flex-shrink: 0;\n}\n\n.akm-status-text { font-size: 13px; font-weight: 500; color: #374151; }\n\n.akm-reprint-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  background: #fff;\n  border: 1px solid #d1d5db;\n  border-radius: 30px;\n  padding: 5px 12px;\n  cursor: pointer;\n  font-family: inherit;\n  transition: all 0.12s;\n  height: 32px;\n}\n\n.akm-reprint-btn:hover:not(:disabled) { background: #f3f4f6; border-color: #9ca3af; }\n.akm-reprint-btn:disabled { opacity: 0.6; cursor: not-allowed; }\n\n/* ── Grand total bar ────────────────────────────────────── */\n.akm-grand-total {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  border-top: 1.5px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.akm-grand-total-label {\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.akm-grand-total-amount { font-size: 1.1rem; font-weight: 800; color: #111827; }\n\n/* ── List view ──────────────────────────────────────────── */\n.akm-list-view { display: flex; flex-direction: column; gap: 10px; }\n\n.akm-list-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid #f0f2f5;\n}\n\n.akm-list-item:last-child { border-bottom: none; }\n.akm-list-item.recalled { opacity: 0.65; }\n.akm-list-item.complimentary { background: #f0fdf4; border-radius: 6px; padding: 10px 8px; }\n\n.akm-list-item-left { display: flex; align-items: flex-start; gap: 8px; flex: 1; min-width: 0; }\n\n.akm-list-item-name { font-size: 13px; font-weight: 600; color: #111827; }\n\n.akm-list-item-addon {\n  font-size: 11px;\n  color: #6b7280;\n  margin: 3px 0 0;\n  padding: 0;\n  line-height: 1.4;\n}\n\n.akm-list-item-price { font-size: 13px; font-weight: 700; color: #1f2937; white-space: nowrap; flex-shrink: 0; }\n\n/* ═══ DARK THEME — AllKotsModal ═══ */\n.dark .akm-title { color: #f1f5f9; }\n.dark .akm-toggle-label { color: #cbd5e1; }\n.dark .akm-subtitle { color: #94a3b8; border-bottom-color: #334155; }\n.dark .akm-close-btn { color: #64748b; }\n.dark .akm-close-btn:hover { background: #334155; }\n\n.dark .akm-body { scrollbar-color: #334155 transparent; }\n.dark .akm-empty { color: #64748b; }\n\n.dark .akm-group {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .akm-group-header { background: #1e293b; border-bottom-color: #334155; }\n.dark .akm-group-header:hover { background: #243043; }\n.dark .akm-group-title { color: #f1f5f9; }\n.dark .akm-group-meta  { color: #64748b; }\n\n.dark .akm-item-card {\n  background: #0f172a;\n  border-color: #334155;\n}\n.dark .akm-item-card.recalled    { background: #2d0a0a; border-color: #7f1d1d; }\n.dark .akm-item-card.complimentary { background: #052e16; border-color: #14532d; }\n\n.dark .akm-item-card-name    { color: #e2e8f0; }\n.dark .akm-item-card-variant { color: #94a3b8; }\n.dark .akm-item-card-addons  { color: #64748b; }\n.dark .akm-item-card-note    { color: #fbbf24; }\n.dark .akm-item-card-kot-label { color: #64748b; }\n\n.dark .akm-item-price-box {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .akm-item-price-box.comp-price { background: #052e16; border-color: #14532d; }\n.dark .akm-price-main  { color: #f1f5f9; }\n.dark .akm-price-zero  { color: #f1f5f9; }\n.dark .akm-price-strike { color: #64748b; }\n\n.dark .akm-action-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n.dark .akm-action-btn.comp:hover:not(:disabled) { background: #334155; }\n.dark .akm-action-btn.repeat { background: #1e3a8a; border-color: #1d4ed8; color: #93c5fd; }\n.dark .akm-action-btn.repeat:hover:not(:disabled) { background: #1e40af; }\n.dark .akm-action-btn.serve { background: #052e16; border-color: #14532d; color: #6ee7b7; }\n.dark .akm-action-btn.serve:hover:not(:disabled) { background: #064e3b; }\n.dark .akm-action-btn.recall { background: #1e293b; border-color: #991b1b; color: #fca5a5; }\n.dark .akm-action-btn.recall:hover { background: #2d0a0a; }\n.dark .akm-action-btn.remove-comp { background: #052e16; border-color: #14532d; color: #6ee7b7; }\n.dark .akm-action-btn.comp:disabled,\n.dark .akm-action-btn.remove-comp:disabled { background: #1e293b; border-color: #334155; color: #475569; }\n\n.dark .akm-group-footer {\n  background: #0f172a;\n  border-top-color: #334155;\n}\n.dark .akm-group-footer-total { color: #f1f5f9; }\n.dark .akm-status-text { color: #94a3b8; }\n\n.dark .akm-reprint-btn {\n  background: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n.dark .akm-reprint-btn:hover:not(:disabled) { background: #334155; border-color: #475569; }\n\n.dark .akm-grand-total {\n  background: #0f172a;\n  border-top-color: #334155;\n}\n.dark .akm-grand-total-label  { color: #64748b; }\n.dark .akm-grand-total-amount { color: #f1f5f9; }\n\n.dark .akm-list-item { border-bottom-color: #334155; }\n.dark .akm-list-item.complimentary { background: #052e16; }\n.dark .akm-list-item-name  { color: #e2e8f0; }\n.dark .akm-list-item-addon { color: #64748b; }\n.dark .akm-list-item-price { color: #f1f5f9; }\n\n.dark .akm-header { border-bottom-color: #334155; }\n\n/* Per-item kitchen state and elapsed prep window */\n.akm-drawer {\n  background: #fff;\n  color: #111827;\n}\n\n.akm-kitchen-notice {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 11px 14px;\n  margin: 0 0 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 9px;\n  color: #4b5563;\n  background: #f3f4f6;\n  font-size: 12px;\n}\n\n.akm-kitchen-notice.loading { justify-content: flex-start; }\n.akm-kitchen-notice.error { color: #991b1b; background: #fef2f2; border-color: #fecaca; }\n.akm-kitchen-notice > div { display: grid; gap: 3px; }\n.akm-kitchen-notice strong { font-size: 12px; }\n.akm-kitchen-notice span { line-height: 1.4; }\n.akm-kitchen-notice-mark {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #64748b;\n  animation: akmPulse 1.3s ease-in-out infinite alternate;\n}\n\n@keyframes akmPulse { to { opacity: 0.35; } }\n\n.akm-kitchen-retry {\n  flex-shrink: 0;\n  padding: 6px 11px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  color: inherit;\n  background: transparent;\n  font: inherit;\n  font-weight: 700;\n  cursor: pointer;\n}\n.akm-kitchen-retry:hover { background: rgba(71, 85, 105, 0.08); }\n\n.akm-kitchen-progress {\n  display: grid;\n  gap: 6px;\n  padding: 9px 10px;\n  margin-top: 9px;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  background: #f9fafb;\n  color: #4b5563;\n  font-size: 11px;\n}\n\n.akm-kitchen-progress-top,\n.akm-kitchen-state,\n.akm-kitchen-progress-bottom {\n  display: flex;\n  align-items: center;\n}\n.akm-kitchen-progress-top { justify-content: space-between; gap: 6px 10px; flex-wrap: wrap; }\n.akm-kitchen-state { gap: 6px; min-width: 0; }\n.akm-kitchen-state-dot { width: 7px; height: 7px; border-radius: 50%; background: #6b7280; flex: 0 0 auto; }\n.akm-kitchen-state-label { color: #374151; font-weight: 700; }\n.akm-kitchen-time-text { color: #6b7280; font-variant-numeric: tabular-nums; }\n.akm-kitchen-time-text strong { font-size: 14px; font-weight: 800; }\n.akm-kitchen-progress.tone-green .akm-kitchen-time-text { color: #15803d; }\n.akm-kitchen-progress.tone-orange .akm-kitchen-time-text { color: #b45309; }\n.akm-kitchen-facts { display: flex; gap: 18px; flex-wrap: wrap; }\n.akm-kitchen-facts span { display: flex; align-items: baseline; gap: 5px; }\n.akm-kitchen-facts b { color: #6b7280; font-weight: 600; }\n.akm-kitchen-prep-fact { flex-wrap: wrap; }\n.akm-kitchen-prep-source { color: #6b7280; font-size: 10px; }\n.akm-kitchen-progress-bottom { gap: 6px 9px; flex-wrap: wrap; }\n.akm-kitchen-meter {\n  height: 5px;\n  flex: 1;\n  min-width: 64px;\n  overflow: hidden;\n  border-radius: 999px;\n  background: #e5e7eb;\n}\n.akm-kitchen-meter-fill { display: block; height: 100%; border-radius: inherit; background: #15803d; }\n.akm-kitchen-progress-label { white-space: nowrap; color: #4b5563; font-variant-numeric: tabular-nums; }\n.akm-kitchen-progress.tone-green .akm-kitchen-state-dot,\n.akm-kitchen-progress.tone-green .akm-kitchen-meter-fill { background: #15803d; }\n.akm-kitchen-progress.tone-orange .akm-kitchen-state-dot,\n.akm-kitchen-progress.tone-orange .akm-kitchen-meter-fill { background: #b45309; }\n.akm-kitchen-progress.tone-red .akm-kitchen-state-dot,\n.akm-kitchen-progress.tone-red .akm-kitchen-meter-fill { background: #b91c1c; }\n.akm-kitchen-progress.tone-red .akm-kitchen-time-text,\n.akm-kitchen-progress.tone-red .akm-kitchen-progress-label { color: #b91c1c; font-weight: 700; }\n.akm-kitchen-progress.tone-neutral .akm-kitchen-state-dot { background: #6b7280; }\n.akm-kitchen-state.cancelled .akm-kitchen-state-label { color: #b91c1c; }\n.akm-kitchen-progress .akm-kitchen-state.cancelled .akm-kitchen-state-dot { background: #b91c1c; }\n\n.dark .akm-drawer { background: #0f172a; color: #f1f5f9; }\n.dark .akm-kitchen-notice { color: #cbd5e1; background: #1e293b; border-color: #334155; }\n.dark .akm-kitchen-notice.error { color: #fecaca; background: #3b1717; border-color: #7f1d1d; }\n.dark .akm-kitchen-progress { color: #cbd5e1; background: #0f172a; border-color: #334155; }\n.dark .akm-kitchen-state-label { color: #e2e8f0; }\n.dark .akm-kitchen-state.cancelled .akm-kitchen-state-label { color: #fca5a5; }\n.dark .akm-kitchen-progress .akm-kitchen-state.cancelled .akm-kitchen-state-dot { background: #ef4444; }\n.dark .akm-kitchen-time-text,\n.dark .akm-kitchen-progress-label { color: #cbd5e1; }\n.dark .akm-kitchen-facts b,\n.dark .akm-kitchen-prep-source { color: #94a3b8; }\n.dark .akm-kitchen-meter { background: #334155; }\n.dark .akm-kitchen-progress.tone-red .akm-kitchen-time-text,\n.dark .akm-kitchen-progress.tone-red .akm-kitchen-progress-label { color: #fca5a5; }\n.dark .akm-kitchen-progress.tone-red .akm-kitchen-state-dot,\n.dark .akm-kitchen-progress.tone-red .akm-kitchen-meter-fill { background: #ef4444; }\n.dark .akm-kitchen-progress.tone-orange .akm-kitchen-state-dot,\n.dark .akm-kitchen-progress.tone-orange .akm-kitchen-meter-fill { background: #f59e0b; }\n.dark .akm-kitchen-progress.tone-green .akm-kitchen-state-dot,\n.dark .akm-kitchen-progress.tone-green .akm-kitchen-meter-fill { background: #22c55e; }\n\n@media (max-width: 767px) {\n  .akm-drawer { width: 100vw !important; }\n  .akm-header { padding: 15px 14px 12px; }\n  .akm-header-left { gap: 10px; }\n  .akm-title { font-size: 1.05rem; }\n  .akm-subtitle { padding: 8px 14px 11px; }\n  .akm-body { padding: 10px 10px 14px; }\n  .akm-group-body { padding: 9px; }\n  .akm-item-card { padding: 11px; }\n  .akm-kitchen-facts { gap: 6px 13px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
